const URLS =  {
    ARBITER_BASE_PATH : "/portal/arbiter",
    ARBITER_API_BASE_PATH : "/api/v1",
    ARBITER_API_TRANSACTIONS: "/transactions",
    ARBITER_API_TRANSACTION_TYPES: "/transactions/types",
    ARBITER_API_TRANSACTION_TYPE: "/transaction-types",
    ARBITER_API_TRANSACTIONS_STORES: "/transactions/stores",
    ARBITER_API_TRANSACTION_GROUPS : "/transaction-groups",
    ARBITER_API_TRANSACTIONS_GROUPS : "/transactions/groups",
    ARBITER_API_TRANSACTION_TIMELINES : "/transaction-timelines",

    ARBITER_API_SCRIPTS :  "/scripts",
    ARBITER_API_DISPUTES : "/disputes",
    ARBITER_API_DISPUTES_BATCHES : "/disputes/batches",
    ARBITER_API_DISPUTE_TIMELINES : "/dispute-timelines",
    ARBITER_API_REASON_CODES : "/reason-codes",
    ARBITER_API_DISPUTE_REGIONS : "/dispute-regions",
    ARBITER_API_DISPUTES_CATEGORIES : "/disputes/categories",
    ARBITER_API_DOWNLOAD_TEMPLATE : "/batches/templates",
    ARBITER_API_DOWNLOAD_ERROR_FILE :"/batches/files",

    ARBITER_API_MERCHANT_DISPUTANTS : "/merchant-disputants",

    USER_API_USER_PERMISSIONS : "/user/permissions"
};
export default URLS


// WEBPACK FOOTER //
// ./src/configurations/urls.js